import {
	faChevronLeft,
	faEdit,
	faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { store } from "react-notifications-component";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	Col,
	FormGroup,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Spinner,
} from "reactstrap";
import Select from "react-select";
import { Dispatch } from "redux";
import { showAlert } from "../../common/functions";
import ManageCategoryModal from "./videoHotlineCategoryDetail";
import { VideoHotlineCategoryAction } from "../../../actions/videoHotlineCategoryAction";
import { set } from "cypress/types/lodash";

interface MusicPlatformProps {
	dispatch: Dispatch<any>;
	videoHotlineCategoryData: any;
}

const VideoHotlineCategoryList: React.SFC<MusicPlatformProps> = ({
	dispatch,
	videoHotlineCategoryData,
}) => {
	const history = useHistory();
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [selectedId, setSelectedId] = useState(-1);
	const [editedId, setEditedId] = useState(0);
	const [showModal, setShowModal] = useState(false);
	const [openDetailModal, setOpenDetailModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [searchText, setSearch] = useState<string>("");
	const [debouncedSearch, setDebouncedSearch] = useState<string>("");
	const [selectedStatus, setSelectedStatus] = useState<any>(null);
	const [detailLoading, isUpdateDetailLoading] = useState<boolean>(false);
	const [updatedStatus, setUpdatedStatus] = useState<boolean>(false);
	const [showStatusModal, setShowStatusModal] = useState<boolean>(false);

	React.useEffect(() => {
		const handler = setTimeout(() => {
			setCurrentPage(1);
			setDebouncedSearch(searchText);
		}, 400);
		return () => {
			clearTimeout(handler);
		};
	}, [searchText]);

	React.useEffect(() => {
		const body = {
			pageNumber: currentPage,
			pageSize: 25,
			searchText: debouncedSearch.trim().length ? debouncedSearch : null,
			isActive: selectedStatus,
		};
		setShowModal(true);
		dispatch(VideoHotlineCategoryAction.videoHotlineCategoryGetByFilter(body));
	}, [debouncedSearch]);

	React.useEffect(() => {
		if (
			videoHotlineCategoryData?.isUpdateStatus &&
			videoHotlineCategoryData.isSuccess
		) {
			const body = {
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch.trim().length ? debouncedSearch : null,
				isActive: selectedStatus,
			};
			setShowModal(true);
			dispatch(
				VideoHotlineCategoryAction.videoHotlineCategoryGetByFilter(body)
			);
			const alertMessage = videoHotlineCategoryData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				videoHotlineCategoryData.isUpdateStatus = false;
				videoHotlineCategoryData.isSuccess = false;
				videoHotlineCategoryData.status = "";
				toggleDetailModal();
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [videoHotlineCategoryData?.isUpdateStatus]);

	React.useEffect(() => {
		if (
			videoHotlineCategoryData?.isSuccessSave &&
			videoHotlineCategoryData?.isSuccess
		) {
			const body = {
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch.trim().length ? debouncedSearch : null,
				isActive: selectedStatus,
			};
			setShowModal(true);
			dispatch(
				VideoHotlineCategoryAction.videoHotlineCategoryGetByFilter(body)
			);
			const alertMessage = videoHotlineCategoryData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				videoHotlineCategoryData.isSuccessSave = false;
				videoHotlineCategoryData.isSuccess = false;
				videoHotlineCategoryData.status = "";
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [videoHotlineCategoryData?.isSuccessSave]);

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	};

	const handleLoadDeleteModal = () => {
		dispatch(VideoHotlineCategoryAction.videoHotlineCategoryDelete(selectedId));
		setShowModal(true);
		setShowDeleteModal(false);
	};

	const toggleDetailModal = () => {
		setOpenDetailModal(false);
		setEditedId(0);
	};

	if (
		videoHotlineCategoryData &&
		!videoHotlineCategoryData.isLoading &&
		videoHotlineCategoryData.isListSuccess
	) {
		videoHotlineCategoryData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}
	if (
		selectedId >= 0 &&
		videoHotlineCategoryData.isSuccess &&
		videoHotlineCategoryData.isDeleteCompleted &&
		!videoHotlineCategoryData.isError
	) {
		showAlert(videoHotlineCategoryData.status, false);
		videoHotlineCategoryData.isSuccess = false;
		videoHotlineCategoryData.isDeleteCompleted = false;
		const body = {
			pageNumber:
				videoHotlineCategoryData?.items?.eventCategories?.length === 1
					? currentPage - 1
					: currentPage,
			pageSize: 25,
			searchText: debouncedSearch.trim().length ? debouncedSearch : null,
			isActive: selectedStatus,
		};
		setShowModal(true);
		dispatch(VideoHotlineCategoryAction.videoHotlineCategoryGetByFilter(body));
		setCurrentPage(
			videoHotlineCategoryData?.items?.eventCategories?.length === 1
				? currentPage - 1
				: currentPage
		);
		setSelectedId(-1);
	}

	if (!videoHotlineCategoryData.isSuccess && videoHotlineCategoryData.isError) {
		if (videoHotlineCategoryData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlert(videoHotlineCategoryData.status, true);
		}
		videoHotlineCategoryData.isError = false;
		isUpdateDetailLoading(!detailLoading);
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	const handleSelectForDelete = (id: any) => {
		videoHotlineCategoryData.isSuccessSave = false;
		videoHotlineCategoryData.isSuccess = false;
		setSelectedId(id);
		setShowDeleteModal(true);
	};

	const handleChangeStatus = (id: any, status: any) => {
		setShowStatusModal(true);
		setSelectedId(id);
		setUpdatedStatus(status);
	};

	const handleActiveCategory = async (id: any, status: any) => {
		const data = {
			eventCategoryId: id,
			isActive: !status,
		};
		setShowModal(true);
		await dispatch(
			VideoHotlineCategoryAction.videoHotlineCategoryUpdateStatus(data)
		);
		setShowStatusModal(false);
	};

	const handleStatusDropdown = async (value: string) => {
		setCurrentPage(1);
		setShowModal(true);
		let isActive: boolean | null;
		if (value === "active") {
			setSelectedStatus(true);
			isActive = true;
		} else if (value === "inactive") {
			setSelectedStatus(false);
			isActive = false;
		} else {
			setSelectedStatus(null);
			isActive = null;
		}
		const body = {
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch.trim().length ? debouncedSearch : null,
			isActive,
		};
		dispatch(VideoHotlineCategoryAction.videoHotlineCategoryGetByFilter(body));
	};
	return (
		<div
			data-testid="videoHotlineCategoryPage"
			className="videoHotlineCategory-list"
		>
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={() => history.push("/videohotline")}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to List
					</CardLink>
				</div>
			</div>
			<div className="card-box">
				<Row className="filter-link-container justify-content-between">
					<Col lg="3">
						<Input
							type="search"
							onChange={(event) => setSearch(event.target.value)}
							className="form-control"
							id="search-filter"
							placeholder="Search here..."
							value={searchText}
						/>
					</Col>
					<Col
						lg={9}
						className="d-flex justify-content-end align-items-center gap-2"
					>
						<Col lg={3}>
							<Select
								id="statusSelect"
								className="status-select"
								placeholder="Select Status"
								isClearable
								options={[
									{ value: "active", label: "Active" },
									{ value: "inactive", label: "Inactive" },
								]}
								onChange={(selected) => {
									if (selected) {
										handleStatusDropdown(selected.value);
									} else {
										handleStatusDropdown("");
									}
								}}
								styles={{
									clearIndicator: (base) => ({
										...base,
										cursor: "pointer",
									}),
								}}
							/>
						</Col>
						<Button
							id="submit"
							data-testid="createNewvideoHotlineCategory"
							className="btn-gray"
							onClick={() => {
								setOpenDetailModal(true);
							}}
						>
							Add New Category
						</Button>
					</Col>
				</Row>
			</div>

			<div className="videoHotlineCategory-table">
				<table
					className="table table-hover"
					data-testid="videoHotlineCategoryTable"
				>
					<thead data-testid="videoHotlineCategoryTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th scope="col" data-testid="categoryname-th">
								Category Name
							</th>
							<th scope="col" data-testid="status-th">
								Status
							</th>
							<th scope="col" data-testid="delete-th">
								Delete
							</th>
						</tr>
					</thead>
					<tbody data-testid="videoHotlineCategoryTableBody">
						{showModal ? (
							<tr>
								<td colSpan={6} className="text-center">
									<Spinner />
								</td>
							</tr>
						) : (
							<>
								{videoHotlineCategoryData &&
								videoHotlineCategoryData?.items?.eventCategories?.length > 0 ? (
									videoHotlineCategoryData?.items?.eventCategories?.map(
										(data: any, i: number) => (
											<>
												<tr key={data.eventCategoryId}>
													<th
														scope="row"
														className="icon-column"
														data-testid={`videoHotlineCategoryDetailButton${
															i + 1
														}`}
													>
														<FontAwesomeIcon
															size="2x"
															icon={faEdit}
															title="Details"
															cursor="pointer"
															className="detailButton"
															onClick={() => {
																setOpenDetailModal(true);
																setEditedId(data?.eventCategoryId);
															}}
														/>
													</th>
													<td id="platformName">{data?.categoryName} </td>
													<td id="actionswitch" className="text-center">
														<FormGroup switch>
															<Input
																type="switch"
																className="active-switch"
																data-testid="hotlineCategoryUpdateStatus"
																id="activeInactiveSwitch"
																checked={data?.isActive}
																onChange={() =>
																	handleChangeStatus(
																		data?.eventCategoryId,
																		data?.isActive
																	)
																}
															/>
														</FormGroup>
													</td>

													<td className="icon-column">
														<FontAwesomeIcon
															size="2x"
															icon={faTrashAlt}
															data-testid="videoHotlineCategoryDeleteButton"
															data-bs-toggle="tooltip"
															cursor="pointer"
															data-bs-placement="bottom"
															title="Delete"
															onClick={() =>
																handleSelectForDelete(data?.eventCategoryId)
															}
														/>
													</td>
												</tr>
											</>
										)
									)
								) : (
									<tr>
										<td colSpan={6} className="text-center h6">
											No Data found.
										</td>
									</tr>
								)}
							</>
						)}
					</tbody>
				</table>
			</div>
			<div className="pagination">
				<ReactPaginate
					previousLabel={"<<"}
					nextLabel={">>"}
					breakLabel={"..."}
					pageCount={Math.ceil(+videoHotlineCategoryData?.items?.totalCount / 25)}
					marginPagesDisplayed={2}
					pageRangeDisplayed={3}
					onPageChange={(data) => {
						setCurrentPage(data.selected + 1);
						const body = {
							pageNumber: data.selected + 1,
							pageSize: 25,
							searchText: debouncedSearch.trim().length
								? debouncedSearch
								: null,
							isActive: selectedStatus,
						};
						setShowModal(true);
						dispatch(
							VideoHotlineCategoryAction.videoHotlineCategoryGetByFilter(body)
						);
					}}
					containerClassName={"pagination"}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={"active"}
					forcePage={currentPage - 1}
				/>
			</div>
			<Modal
				isOpen={showDeleteModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Delete Category</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteCategoryForm">
						<div
							className="col-form-label"
							data-testid="manageCategoryDeleteMessage"
						>
							Deleting this category will permanently remove. To confirm, please
							click Confirm Delete.
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={handleCloseClick}
						data-testid="cancelDeleteButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadDeleteModal}
						data-testid="confirmDeleteButton"
					>
						Confirm Delete
					</Button>
				</ModalFooter>
			</Modal>
			<Modal
				isOpen={showStatusModal}
				backdrop="static"
				centered
				data-testid="statusModal"
			>
				<ModalHeader>Update Status</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteStatusForm">
						<div
							className="col-form-label"
							data-testid="manageCategoryUpdateMessage"
						>
							Only one category can be active at a time. Activating this
							category will deactivate the currently active one. Do you want to
							continue?
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={() => setShowStatusModal(false)}
						data-testid="cancelUpdateButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={() => handleActiveCategory(selectedId, updatedStatus)}
						data-testid="confirmUpdateButton"
					>
						Confirm Update
					</Button>
				</ModalFooter>
			</Modal>
			<ManageCategoryModal
				isOpen={openDetailModal}
				toggleDetailModal={toggleDetailModal}
				id={editedId}
				dispatch={dispatch}
				videoHotlineCategoryData={videoHotlineCategoryData}
				detailLoading={detailLoading}
			/>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { videoHotlineCategoryData } = state;
	return {
		videoHotlineCategoryData,
	};
};

export default connect(mapStateToProps)(VideoHotlineCategoryList);
